module.exports = __webpack_public_path__ + "1.5.0-unryo/img/microsoft-sql-server.35528815.svg";